<template>
    <div class="component">
        <vue-headful
            title="previews List | W&S Docs"
        />
        <div v-if="loading" class="loading">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="result" class="alert alert-secondary text-success font-weight-bold" role="alert">
            Успешно удалено!
        </div>

        <div class="form-group">
            <router-link class="btn bg-dark text-white" to="/admin/previews/add">Добавить превью</router-link>
        </div>

        <ul class="list-group list-group-flush">
            <li class="list-group-item bg-dark d-flex align-items-center justify-content-between" v-for="(preview, index) in previews" :key="index">
                <div class="form-group m-0">
                    {{ preview.preview_link }}
                    <small class="form-text text-muted">{{ preview.preview_desc }}</small>
                </div>
                <div class="form-group m-0">
                    <router-link :to="'/admin/previews/edit/' + preview.preview_link" class="btn p-1" title="Edit">
                        <i class="far fa-edit"></i>
                    </router-link>
                    <span class="btn p-1" @click="deletepreview(index, preview.preview_id)" title="Delete">
                        <i class="fas fa-times-circle"></i>
                    </span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "previewsList",
        data() {
            return {
                previews: [],
                loading: true,
                result: false
            }
        },
        mounted() {
            axios.get('https://api.write-and-share.ml/docs/preview.get')
                .then(response => {
                    this.previews = response.data.response
                })
                .finally(this.loading = false);
        },
        methods: {
            deletepreview: function (index, preview_id) {
                axios.get('https://api.write-and-share.ml/docs/preview.delete?preview_id=' + preview_id)
                    .then(
                        this.result = true,
                        this.previews.splice(index, preview_id)
                    )
            },
        }
    }
</script>

<style scoped>

</style>
